export default __webpack_public_path__ + "static/media/results-page-blur-medium.001cd259.png";